<!-- AI Assistant launcher hidden
@if (!store.isOpen()) {
    <button mat-fab
            type="button"
            class="chat-fab"
            (click)="store.openPanel()"
            matTooltip="AI Assistant">
        <mat-icon>smart_toy</mat-icon>
    </button>
}
-->
@if (store.isOpen()) {
    <mat-card class="chat-panel">
        <mat-card-header class="chat-header">
            <mat-card-title>AI Assistant</mat-card-title>
            <span class="header-spacer"></span>
            @if (store.isReconnecting()) {
                <span class="reconnecting-badge">Reconnecting…</span>
            }
            <button mat-icon-button
                    type="button"
                    matTooltip="Clear conversation"
                    [disabled]="!store.hasMessages()"
                    (click)="onClear()">
                <mat-icon>delete_sweep</mat-icon>
            </button>
            <button mat-icon-button
                    type="button"
                    (click)="store.togglePanel()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>

        <mat-card-content class="chat-content">
            <div #scrollContainer class="messages-area">
                @for (msg of store.messages(); track msg.id) {
                    @if (msg.role === 'confirmation') {
                        <div class="confirmation-card">
                            <p class="confirmation-description">{{ msg.content }}</p>
                            @if (store.pendingConfirmation()?.actionId === msg.actionId) {
                                <div class="confirmation-actions">
                                    <button mat-raised-button
                                            color="warn"
                                            type="button"
                                            (click)="onConfirm(msg.actionId!, false)">
                                        Reject
                                    </button>
                                    <button mat-raised-button
                                            color="primary"
                                            type="button"
                                            (click)="onConfirm(msg.actionId!, true)">
                                        Confirm
                                    </button>
                                </div>
                            } @else {
                                <span class="confirmation-resolved">
                                    {{ msg.confirmed ? 'Confirmed' : 'Rejected' }}
                                </span>
                            }
                        </div>
                    } @else {
                        <na-ai-agent-chat-message [message]="msg" />
                    }
                }

                @if (store.streamingContent()) {
                    <div class="streaming-bubble">{{ store.streamingContent() }}</div>
                }

                @if (store.isThinking()) {
                    <div class="loading-indicator">
                        <mat-progress-spinner mode="indeterminate" diameter="20" />
                        @if (store.activeToolName()) {
                            <span>{{ store.activeToolName() }}…</span>
                        } @else {
                            <span>Thinking…</span>
                        }
                    </div>
                }

                @if (store.showEmptyState()) {
                    <p class="empty-state">Ask me anything about subscriptions or users.</p>
                }
            </div>
        </mat-card-content>

        <mat-card-actions class="chat-actions">
            <mat-form-field class="input-field" appearance="outline" subscriptSizing="dynamic">
                <textarea matInput
                          rows="1"
                          placeholder="Type a message…"
                          [ngModel]="store.inputText()"
                          (ngModelChange)="store.setInputText($event)"
                          (keydown)="onKeyDown($event)"
                          [disabled]="store.isInputDisabled()">
                </textarea>
            </mat-form-field>
            <button mat-icon-button
                    color="primary"
                    type="button"
                    [disabled]="!store.canSend()"
                    (click)="onSend()">
                <mat-icon>send</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>
}
